import { Alert, Box, Button, Card, Container, Divider, Link, TextField, Typography } from "@mui/material";
import { Info, Warning } from "@mui/icons-material";

export default function Register() {
    return (
        <Container maxWidth="lg" sx={{ alignContent: "center", display: "flex", height: '100%', alignItems: "center" }}>
            <Card sx={{ padding: 4,  marginX: "auto", width:"100%", maxWidth: 400, boxShadow:{xs:'none', md:'var(--Paper-shadow)'} }}>
                <Typography variant="h4" sx={{ marginBottom: 4 }}>
                    Register
                </Typography>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Username" placeholder="Use your active phone as username" variant="outlined" fullWidth={true}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="New password" placeholder="Atleast 8 characters" variant="outlined" type="password" fullWidth={true}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="First name" variant="outlined" fullWidth={true}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Last name" variant="outlined" fullWidth={true}></TextField>
                </Box>
                <Alert icon={<Info></Info>} severity="success" sx={{ marginBottom: 4 }}>You will receive a message with a temporary password.</Alert>
                <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginBottom: 4 }}>The username and password did not match.</Alert>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Link href="/sign-in" variant="body2">Go to login</Link>
                    <Button variant="contained">Submit</Button>
                </Box>
            </Card>
        </Container>
    );
}